export enum Countries {
  USA = 1,
}

export enum AddressTypes {
  PERMANENT = 1,
}

export enum Products {
  LOC = 1,
  REFI = 2,
  PEL = 3,
}

export enum Flows {
  STRICT = 1,
  MDDO = 2,
  MEDICAL = 3,
  PROF = 4,
}

export enum Programs {
  UNDERGRADUATE = 1,
  DOMESTIC_GRADUATE = 2,
  INTERNATIONAL_GRADUATE = 3,
  PARENT = 4,
  ADVANCED_DEGREE = 5,
  MEDICAL = 6,
  STANDARD = 7,
  INTERNATIONAL_UNDERGRADUATE = 8,
  DOMESTIC_GRADUATE2 = 9,
  BIO_MEDICAL1 = 10,
  REACH = 11,
  AVIATION1 = 12,
  AVIATION2 = 13,
  AVIATION3 = 14,
  AVIATION4 = 15,
  AVIATION5 = 16,
  BIO_MEDICAL2 = 17,
  BIO_MEDICAL3 = 18,
  MEDICAL2 = 19,
  MEDICAL3 = 20,
  NURSING1 = 21,
  NURSING2 = 22,
  NURSING3 = 23,
  ENERGY_TRADE_SCHOOL1 = 24,
  ENERGY_TRADE_SCHOOL2 = 25,
  ENERGY_TRADE_SCHOOL3 = 26,
  DENTAL = 27,
  DENTAL2 = 28,
  DENTAL3 = 29,
  PODIATRY = 30,
  PODIATRY2 = 31,
  PODIATRY3 = 32,
  OPTOMETRY = 33,
  OPTOMETRY2 = 34,
  OPTOMETRY3 = 35,
  VETERINARY_MEDICINE = 36,
  VETERINARY_MEDICINE2 = 37,
  VETERINARY_MEDICINE3 = 38,
  LAW = 39,
  LAW2 = 40,
  LAW3 = 41,
  THEOLOGY = 42,
  THEOLOGY2 = 43,
  THEOLOGY3 = 44,
  PHARMACY = 45,
  PHARMACY2 = 46,
  PHARMACY3 = 47,
  CLINICAL_PSYCHOLOGY = 48,
  CLINICAL_PSYCHOLOGY2 = 49,
  CLINICAL_PSYCHOLOGY3 = 50,
  BAR_STUDY = 51,
  BAR_STUDY2 = 52,
  BAR_STUDY3 = 53,
  MEDICAL_OSTEOPATHIC = 54,
  MEDICAL_OSTEOPATHIC2 = 55,
  MEDICAL_OSTEOPATHIC3 = 56,
  MEDICAL_AND_OSTEOPATHIC = 57,
  MEDICAL_AND_OSTEOPATHIC2 = 58,
  MEDICAL_AND_OSTEOPATHIC3 = 59,
  LANDSCAPING = 60,
  ADVANCED_DEGREE2 = 61,
  ADVANCED_DEGREE3 = 62,
  HEALTH_PROFESSIONS = 63,
  HEALTH_PROFESSIONS2 = 64,
  HEALTH_PROFESSIONS3 = 65,
}

export enum ApplicationStatuses {
  NOT_SUBMITTED = 1,
  EVALUATION = 2,
  SUBMITTED_AND_PROCESSING = 3,
  COMPLETE = 4,
  DECLINED = 5,
  CANCELLED = 6,
  SMR_DECLINED = 7,
  RIGHT_TO_CANCEL = 8,
}

export enum ApplicantTypes {
  PRIMARY_APPLICANT = 1,
  CO_APPLICANT = 2,
  STUDENT = 3,
}

// Scope of a custom consent verbiage (ConsentService ApplicationTypes) - not the same
// encoding as the local `applicationTypeId` computeds elsewhere (1 = Solo, 2 = Joint).
export enum ConsentApplicationTypes {
  ALL = 1,
  SOLO = 2,
  JOINT = 3,
}

export enum RateTypes {
  Fixed = 1,
  Variable = 2,
}

export enum ConsentTypes {
  CREDIT = 1,
  ECOMMUNICATION = 2,
  MOBILE = 3,
  TERMS_AND_CONDITIONS = 4,
  EMAIL_VALIDATION = 5,
  SOFT_PULL = 6,
  REFI_UNDERPAYMENT = 7,
  PARENT_ATTESTATION = 13,
}

export enum SurveyQuestionTypes {
  TwoYearsIncome = 1,
  SelectedCreditRange = 2,
  MaritalStatus = 3,
  SMREstimateLoanAmount = 4,
  EmploymentStatus = 5,
  EmployerName = 6,
}

export enum ItinAccessTypes {
  None = 1,
  BorrowerOnly = 2,
  CoborrowerOnly = 3,
  BorrowerOrCoborrower = 4,
  BorrowerAndCoborrower = 5,
}

export enum CitizenshipStatusTypes {
  USCitizen = 1,
  PermanentResident = 2,
  NonCitizen = 3,
  NonUSCitizenWithSSN = 4,
}

export enum ConsentApplicantTypes {
  Primary = 1,
  CoApplicant = 2,
  Both = 3,
}

export enum EnrollmentStatuses {
  FullTime = 1,
  HalfTime = 2,
  LessThanHalfTime = 3,
}

export enum RepaymentTerms {
  TWENTY_YEAR = 5,
  TWENTY_FIVE_YEAR = 6,
}

export enum RepaymentTypes {
  Flat = 1,
  Deferred = 2,
  Interest = 3,
  Regular = 4,
}

export enum ApplicantUserCheckResult {
  NoMatch = 0,
  MatchFound = 1,
  NoRecordByUserId = 2,
}

export enum ConsentServiceEntityTypes {
  Application = 1,
  Loan = 2,
  Draw = 3,
}

export enum MembershipStatusTypes {
  Stated = 1,
  StatedNotAMember = 6,
}

export enum NationalIdNumberTypes {
  SSN = 1,
  ITIN = 2,
}

export enum SchoolTypes {
  AVIATION = 25,
}
